import { render, staticRenderFns } from "./topFilters.vue?vue&type=template&id=95b9521c"
import script from "./topFilters.vue?vue&type=script&lang=js"
export * from "./topFilters.vue?vue&type=script&lang=js"
import style0 from "./topFilters.vue?vue&type=style&index=0&id=95b9521c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports